import { AnimatedSection } from "./AnimatedSection";
import { CONTACT } from "@/lib/contact";

const ROWS = [
  { service: "GST, PF & ESI Returns", fee: "Starts at ₹1,000" },
  { service: "Individual Income Tax Return (ITR)", fee: "Starts at ₹2,000" },
  { service: "Firms & Companies ITR", fee: "Starts at ₹5,000" },
];

export const PricingGuide = () => (
  <section id="pricing" className="bg-white py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <AnimatedSection className="max-w-2xl mb-14">
        <p className="overline text-[#1E3A8A] mb-4">Transparent Pricing</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#0F172A] mb-4">
          Clear, straightforward pricing.
        </h2>
        <p className="text-slate-500 leading-relaxed">
          Every business is different, so we don&apos;t believe in one-size-fits-all packages.
          Below are our base starting prices. Call or WhatsApp us for a quick, exact quote based
          on your specific needs.
        </p>
      </AnimatedSection>

      <AnimatedSection delay={0.1} data-testid="pricing-table-wrapper" className="border border-slate-200 rounded-2xl overflow-hidden">
        <table data-testid="pricing-table" className="w-full border-collapse">
          <thead>
            <tr className="bg-slate-50">
              <th className="text-left font-sans text-sm uppercase tracking-wider text-slate-500 px-6 md:px-10 py-4 font-semibold">
                Service
              </th>
              <th className="text-left font-sans text-sm uppercase tracking-wider text-slate-500 px-6 md:px-10 py-4 font-semibold">
                Starting Fee
              </th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row, i) => (
              <tr key={i} data-testid={`pricing-row-${i}`} className={i !== ROWS.length - 1 ? "border-b border-slate-200" : ""}>
                <td className="font-serif text-lg md:text-xl text-[#0F172A] px-6 md:px-10 py-6 align-top">
                  {row.service}
                </td>
                <td className="text-slate-500 text-base md:text-lg leading-relaxed px-6 md:px-10 py-6 align-top">
                  {row.fee}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </AnimatedSection>

      <AnimatedSection delay={0.2} className="mt-10 flex flex-col sm:flex-row sm:items-center gap-5">
        <p className="text-slate-600 text-base md:text-lg">
          Need pricing for high-volume transactions, company audits, or specialized filings?
        </p>
        <a
          href={CONTACT.whatsappHref}
          target="_blank"
          rel="noreferrer"
          data-testid="pricing-quote-btn"
          className="inline-flex items-center gap-2 rounded-full bg-[#0A1128] text-white px-7 py-3.5 text-base font-medium hover:bg-[#0A1128]/90 transition-colors duration-300 shrink-0"
        >
          Get Your Custom Quote on WhatsApp
        </a>
      </AnimatedSection>
    </div>
  </section>
);
